import './SignUp.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { DocumentUpload } from './components/DocumentUpload/DocumentUpload';
import { DocumentUploadModel } from './components/DocumentUpload/types';
import { SignUp } from './components/SignUp/SignUp';
import { SignupModel } from './components/SignUp/types';

const queryClient = new QueryClient();

const container = document.getElementById('main-app') as HTMLDivElement;
const parsedModel = JSON.parse(container.dataset.model!) as { PageType?: string };

const root = createRoot(container);

if (parsedModel.PageType === 'documentUpload') {
  root.render(
    <QueryClientProvider client={queryClient}>
      <DocumentUpload model={parsedModel as DocumentUploadModel} />
    </QueryClientProvider>
  );
} else {
  root.render(<SignUp model={parsedModel as SignupModel} />);
}
